// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-modal-overlay:has(.page-payment-screen-3-3) {
  background-color: rgba(0, 0, 0, 0.5);
}

.payment-modal:has(.page-payment-screen-3-3) {
  margin: 0 auto;

  border-radius: 24px;
  background-color: var(--white);
}

.payment-modal-overlay .ReactModal__Content--after-open:has(.page-payment-screen-3-3) {
  animation: customEnterModalAnimation 0.5s ease-in-out;
}

.payment-modal-overlay .ReactModal__Content--before-close:has(.page-payment-screen-3-3) {
  animation: customLeaveModalAnimation 0.5s ease-in-out;
}

.page-payment-screen-3-3 .page-title {
  font-weight: 600;
  font-size: 22px;
  line-height: 27px;
  margin: 0 0 24px;
}

.page-payment-screen-3-3 .floating-container {
  backdrop-filter: none;
}

.page-payment-screen-3-3 .paypal-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  box-shadow: -4px -8px 24px 3px #0000000D;
  border-radius: 0 0 24px 24px;
  padding: 24px;

  animation: customEnterModalAnimation 0.5s ease-in-out;
}

.page-payment-screen-3-3 .wallet-button-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  box-shadow: -4px -8px 24px 3px #0000000D;
  border-radius: 0 0 24px 24px;
  padding: 24px;

  animation: customEnterModalAnimation 0.5s ease-in-out;
}

/*UPDATE STYLES FOR COMPONENTS*/
.page-payment-screen-3-3 .payment-method-switcher {
  --switcher-border-radius: 12px;
  gap: 4px;
  margin-bottom: 24px;

  display: flex;
  flex-wrap: wrap;
}

.page-payment-screen-3-3 .payment-method-switcher .method {
  background: var(--light-gray5);

  display: flex;
  justify-content: center;
  align-items: center;
}

.page-payment-screen-3-3 .payment-method-switcher .method.selected {
  background: var(--light-green);
  border-color: var(--green);
}

.page-payment-screen-3-3 .payment-method-switcher .method.paypal svg {
  width: auto;
  padding:0;
}

.page-payment-screen-3-3 .payment-method-switcher .method.credit-card {
  padding: 0;
}

.page-payment-screen-3-3 .payment-method-switcher .method.apple-pay {
  transition: none;
  animation: none;
  -webkit-animation: none;

  order: 99;
  max-width: none;
}

.page-payment-screen-3-3 .payment-method-switcher .method.apple-pay .wallet-icons {
  display: flex;
  align-items: center;
}

.page-payment-screen-3-3 .payment-method-switcher .method.apple-pay span {
  margin-right: 3px;

  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0.05000000074505806px;
}

.page-payment-screen-3-3 .payment-method-switcher:has(.method.apple-pay) .method.credit-card,
.page-payment-screen-3-3 .payment-method-switcher:has(.method.apple-pay) .method.paypal {
  flex: 0 1 49%;
  width: 49%;
  box-sizing: border-box;
}

.page-payment-screen-3-3 .payment-method-switcher:has(.method.google-pay) .method.paypal {
  max-width: none;
}

.page-payment-screen-3-3 .payment-method-switcher .payment-method-icons {
  margin-top: 3px;

  gap: 3px;
  justify-content: space-between;
}

.page-payment-screen-3-3 .payment-method-switcher .payment-method-icons .icon-container {
  width: 17.2px;
  height: 12px;
  border: 0.5px solid var(--light-gray4);
}

.page-payment-screen-3-3 .payment-method-switcher .payment-method-icons .icon-container.amex {
  background-color: #1F72CD;
}

.page-payment-screen-3-3 .payment-method-switcher .payment-method-icons .icon-container svg {
  width: 12.4px;
  height: 7.4px;
  max-width: 100%;
  max-height: 100%;
}

.page-payment-screen-3-3 .receipt .price-container {
  color: var(--dark-gray4);
}

.page-payment-screen-3-3 .receipt .price-wrapper {
  font-weight: normal;
}

.page-payment-screen-3-3 .receipt .discount .price-wrapper {
  color: var(--red3);
}

.page-payment-screen-3-3 .receipt .total-container {
  border-bottom: 0;
}

.page-payment-screen-3-3 .receipt .total-container span{
  font-size: 16px;
  line-height: 19px;
  color: black;
}

.page-payment-screen-3-3 .receipt .total-container .period-description-wrapper {
  margin-top: 8px;

  font-size: 10px;
  font-weight: 400;
  line-height: 13px;
  color: var(--dark-gray4);
}

.page-payment-screen-3-3 .receipt .total-container .period-description-wrapper::first-letter {
  text-transform: uppercase;
}

.page-payment-screen-3-3 .receipt .total-container .period-price-wrapper {
  margin-top: 7px;

  font-size: 12px;
  font-weight: 700;
  line-height: 14.4px;
}

.page-payment-screen-3-3 .receipt .total-container .price-wrapper {
  color: var(--red3);
}

.page-payment-screen-3-3 .stripe-checkout-form-container {
  margin-top: 16px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  box-shadow: -4px -8px 24px 3px #0000000D;
  border-radius: 0 0 24px 24px;
  padding: 24px;

  animation: customEnterModalAnimation 0.5s ease-in-out;
}

.page-payment-screen-3-3 .stripe-checkout-form-container .button-container .btn {
  border-radius: 12px;

  font-size: 18px;
  font-weight: 700;
}

.page-payment-screen-3-3 .loading-title {
  font-weight: 600;
  line-height: normal;
  margin: 32px auto 0;
}

.page-payment-screen-3-3 .loading-title:after {
  display: inline-block;
  animation: dotty steps(1, end) 1s infinite;
  content: '';
}

@keyframes dotty {
  0% {
    content: '';
  }
  25% {
    content: '.';
  }
  50% {
    content: '..';
  }
  75% {
    content: '...';
  }
  100% {
    content: '';
  }
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/payment-screen-v3-3.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;;EAEd,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,wCAAwC;EACxC,4BAA4B;EAC5B,aAAa;;EAEb,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,wCAAwC;EACxC,4BAA4B;EAC5B,aAAa;;EAEb,qDAAqD;AACvD;;AAEA,+BAA+B;AAC/B;EACE,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;;EAEnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,8BAA8B;;EAE9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;;EAEvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;;EAEjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;;EAEf,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;;EAEf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;;EAEf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,wCAAwC;EACxC,4BAA4B;EAC5B,aAAa;;EAEb,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;;EAEnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".payment-modal-overlay:has(.page-payment-screen-3-3) {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.payment-modal:has(.page-payment-screen-3-3) {\n  margin: 0 auto;\n\n  border-radius: 24px;\n  background-color: var(--white);\n}\n\n.payment-modal-overlay .ReactModal__Content--after-open:has(.page-payment-screen-3-3) {\n  animation: customEnterModalAnimation 0.5s ease-in-out;\n}\n\n.payment-modal-overlay .ReactModal__Content--before-close:has(.page-payment-screen-3-3) {\n  animation: customLeaveModalAnimation 0.5s ease-in-out;\n}\n\n.page-payment-screen-3-3 .page-title {\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 27px;\n  margin: 0 0 24px;\n}\n\n.page-payment-screen-3-3 .floating-container {\n  backdrop-filter: none;\n}\n\n.page-payment-screen-3-3 .paypal-container {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: white;\n  box-shadow: -4px -8px 24px 3px #0000000D;\n  border-radius: 0 0 24px 24px;\n  padding: 24px;\n\n  animation: customEnterModalAnimation 0.5s ease-in-out;\n}\n\n.page-payment-screen-3-3 .wallet-button-container {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: white;\n  box-shadow: -4px -8px 24px 3px #0000000D;\n  border-radius: 0 0 24px 24px;\n  padding: 24px;\n\n  animation: customEnterModalAnimation 0.5s ease-in-out;\n}\n\n/*UPDATE STYLES FOR COMPONENTS*/\n.page-payment-screen-3-3 .payment-method-switcher {\n  --switcher-border-radius: 12px;\n  gap: 4px;\n  margin-bottom: 24px;\n\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.page-payment-screen-3-3 .payment-method-switcher .method {\n  background: var(--light-gray5);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.page-payment-screen-3-3 .payment-method-switcher .method.selected {\n  background: var(--light-green);\n  border-color: var(--green);\n}\n\n.page-payment-screen-3-3 .payment-method-switcher .method.paypal svg {\n  width: auto;\n  padding:0;\n}\n\n.page-payment-screen-3-3 .payment-method-switcher .method.credit-card {\n  padding: 0;\n}\n\n.page-payment-screen-3-3 .payment-method-switcher .method.apple-pay {\n  transition: none;\n  animation: none;\n  -webkit-animation: none;\n\n  order: 99;\n  max-width: none;\n}\n\n.page-payment-screen-3-3 .payment-method-switcher .method.apple-pay .wallet-icons {\n  display: flex;\n  align-items: center;\n}\n\n.page-payment-screen-3-3 .payment-method-switcher .method.apple-pay span {\n  margin-right: 3px;\n\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 28px;\n  letter-spacing: 0.05000000074505806px;\n}\n\n.page-payment-screen-3-3 .payment-method-switcher:has(.method.apple-pay) .method.credit-card,\n.page-payment-screen-3-3 .payment-method-switcher:has(.method.apple-pay) .method.paypal {\n  flex: 0 1 49%;\n  width: 49%;\n  box-sizing: border-box;\n}\n\n.page-payment-screen-3-3 .payment-method-switcher:has(.method.google-pay) .method.paypal {\n  max-width: none;\n}\n\n.page-payment-screen-3-3 .payment-method-switcher .payment-method-icons {\n  margin-top: 3px;\n\n  gap: 3px;\n  justify-content: space-between;\n}\n\n.page-payment-screen-3-3 .payment-method-switcher .payment-method-icons .icon-container {\n  width: 17.2px;\n  height: 12px;\n  border: 0.5px solid var(--light-gray4);\n}\n\n.page-payment-screen-3-3 .payment-method-switcher .payment-method-icons .icon-container.amex {\n  background-color: #1F72CD;\n}\n\n.page-payment-screen-3-3 .payment-method-switcher .payment-method-icons .icon-container svg {\n  width: 12.4px;\n  height: 7.4px;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.page-payment-screen-3-3 .receipt .price-container {\n  color: var(--dark-gray4);\n}\n\n.page-payment-screen-3-3 .receipt .price-wrapper {\n  font-weight: normal;\n}\n\n.page-payment-screen-3-3 .receipt .discount .price-wrapper {\n  color: var(--red3);\n}\n\n.page-payment-screen-3-3 .receipt .total-container {\n  border-bottom: 0;\n}\n\n.page-payment-screen-3-3 .receipt .total-container span{\n  font-size: 16px;\n  line-height: 19px;\n  color: black;\n}\n\n.page-payment-screen-3-3 .receipt .total-container .period-description-wrapper {\n  margin-top: 8px;\n\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 13px;\n  color: var(--dark-gray4);\n}\n\n.page-payment-screen-3-3 .receipt .total-container .period-description-wrapper::first-letter {\n  text-transform: uppercase;\n}\n\n.page-payment-screen-3-3 .receipt .total-container .period-price-wrapper {\n  margin-top: 7px;\n\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 14.4px;\n}\n\n.page-payment-screen-3-3 .receipt .total-container .price-wrapper {\n  color: var(--red3);\n}\n\n.page-payment-screen-3-3 .stripe-checkout-form-container {\n  margin-top: 16px;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: white;\n  box-shadow: -4px -8px 24px 3px #0000000D;\n  border-radius: 0 0 24px 24px;\n  padding: 24px;\n\n  animation: customEnterModalAnimation 0.5s ease-in-out;\n}\n\n.page-payment-screen-3-3 .stripe-checkout-form-container .button-container .btn {\n  border-radius: 12px;\n\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.page-payment-screen-3-3 .loading-title {\n  font-weight: 600;\n  line-height: normal;\n  margin: 32px auto 0;\n}\n\n.page-payment-screen-3-3 .loading-title:after {\n  display: inline-block;\n  animation: dotty steps(1, end) 1s infinite;\n  content: '';\n}\n\n@keyframes dotty {\n  0% {\n    content: '';\n  }\n  25% {\n    content: '.';\n  }\n  50% {\n    content: '..';\n  }\n  75% {\n    content: '...';\n  }\n  100% {\n    content: '';\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
